import { Alert, AlertTitle, Grow } from '@mui/material'
import { ReactElement } from 'react'
import hotToast from 'react-hot-toast'

type ToastType = 'success' | 'error' | 'warning' | 'info'
type Options = {
  title?: string
}
type MessageType = string | ReactElement | ReactElement[]

const createToast = (type: ToastType) => (message: MessageType, opt?: Options) => {
  hotToast.custom(
    (t) => (
      <Grow in={t.visible}>
        <Alert severity={type} sx={{ minWidth: '15vw' }}>
          {opt?.title && <AlertTitle>{opt.title}</AlertTitle>}
          {message}
        </Alert>
      </Grow>
    ),
    { duration: 4000 },
  )
}

const toast = (message: MessageType, opt?: Options) => createToast('info')(message, opt)

toast.error = createToast('error')
toast.success = createToast('success')
toast.warning = createToast('warning')
toast.info = createToast('info')

export { toast }
export default toast
